import { cva } from '@/styled-system/css';

export const upsellBannerMediaRecipe = cva({
  base: {
    'lgDown': {
      position: 'absolute',
      insetBlockStart: 'default',
      insetInlineStart: 'default',
    },
    'lg': {
      display: 'flex',
      marginInlineEnd: 'default',
      flexShrink: 0,
    },

    '& > [data-c11n-component="Icon"]': {
      color: 'inherit',
      width: 'icon.xl',
      height: 'icon.xl',
    },
  },
  variants: {
    tone: {
      neutral: {
        color: 'UpsellBanner.Media.neutral.icon',
      },
      soft: {
        color: 'UpsellBanner.Media.soft.icon',
      },
      hero: {
        color: 'UpsellBanner.Media.hero.icon',
      },
      impact: {
        color: 'UpsellBanner.Media.impact.icon',
      },
    },
  },
});
